export const moveToFolderCreateNewAriaLabel = "dxc";
export const moveToFolderCreateNewTooltip = "exc";
export const moveToFolderAddFolderNameText = "fxc";
export default {moveToFolderCreateNewAriaLabel,moveToFolderCreateNewTooltip,moveToFolderAddFolderNameText};